import motion from "@/lib/lazy-motion-tags";
import { Button } from "@/components/ui/button";
import { Phone, MapPin, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { trackPhoneCall } from "@/lib/analytics";

const CTASection = () => {
  return (
    <section className="py-24 bg-accent text-accent-foreground relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FBBF24' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            جاهز لتحويل مساحتك؟
          </h2>
          <p className="text-xl mb-12 text-accent-foreground/80">
            تواصل معنا اليوم واحصل على استشارة مجانية وعرض سعر فوري
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
            <Button asChild size="lg" className="bg-primary text-accent hover:bg-primary/90 font-bold text-lg px-8 py-6 shadow-glow">
              <Link to="/contact">
                اطلب عرض سعر الآن
                <ArrowLeft className="mr-2 h-5 w-5" />
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-2 border-primary text-primary hover:bg-primary hover:text-accent font-bold text-lg px-8 py-6">
              <a href="tel:+966552351116" dir="ltr" onClick={() => trackPhoneCall("cta_section")}>
                <Phone className="ml-2 h-5 w-5" />
                اتصل الآن: +966 55 235 1116
              </a>
            </Button>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex flex-col sm:flex-row gap-8 justify-center items-center"
          >
            <div className="flex items-center gap-3">
              <MapPin className="h-6 w-6 text-primary" />
              <div className="text-right">
                <p className="font-medium">زرنا:</p>
                <p className="text-sm text-accent-foreground/80">حي طويق - صناعية طويق - الرياض</p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
